import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { SearchService } from '@services/search.service';
import { CreateService } from '@services/create.service';
import { SaveService } from '@services/save.service';
import { RemoveService } from '@services/remove.service';
import { GlobalService } from '@common/global';
import * as _ from 'lodash';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { RatingValueComponent } from '@app/social/rating-value/rating-value.component';
@Component({
  selector: 'app-comment-list',
  templateUrl: './comment-list.component.html',
  styleUrls: ['./comment-list.component.sass']
})
export class CommentListComponent implements OnInit {
  @Output() commentCount = new EventEmitter();
  @Input('c') component: string;
  @Input('a') application: string;
  @Input('rows') rows: number;
  @Input('comments_count') comments_count: number;
  @Input('mediaId') mediaId: string;
  @Input('metadata') metadata: object;
  @Input('mediaType') mediaType: string;
  @Input('mediaName') mediaName: string;
  @Input('loginurl') loginurl: string;
  comment_count = 0;
  form_renter = false;
  comments: any = [];
  dataLoding = false;
  params: any = [];
  pageCounter = 1;
  btn_process = false;
  btn_update_process = false;
  isLogin = false;
  commentRate = 0;
  metaComment = true;
  meta_comments: any = [];
  meta: any = [];
  meta_count = 0;
  comment_error: any = { "name": "", "description": "" };
  comment_update_error: any = { "description": "" };
  comment_edit_show: any = {};
  constructor(private _save: SaveService, private _remove: RemoveService, private router: Router, private _createService: CreateService, private fb: FormBuilder, private _searchService: SearchService, private _global: GlobalService) { }
  commentForm: FormGroup;
  commentEditForm: FormGroup;
  @ViewChild(RatingValueComponent, { static: false }) ratingElem: RatingValueComponent;
  ngOnInit(): void {

    // this.loadComment();

    this.meta = this._global.asJsonObject(this._global.getVal(this.metadata, 'comments', []));
    if (this.meta.length > 0) {
      this.meta_comments = this.meta;
      Object.entries(this.meta_comments).forEach(([key, value]) => {
        if (value) {
          this.meta_count = this.meta_count + 1;
        }
      });
    }

    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }
    this.commentForm = this.fb.group({
      name: [],
      description: []
    });
    this.commentEditForm = this.fb.group({
      description: []
    });
  }

  rating(e) {
    this.commentRate = e
  }
  showComments() {
    this.dataLoding = true;
    this.metaComment = false;
    this.loadComment();
  }
  edit(obj) {
    this.comment_edit_show = {};
    this.comment_update_error = { "description": "" };
    this.comment_edit_show[obj['id']] = true;
  }
  updateCancel() {
    this.comment_edit_show = {};
  }
  delete(obj) {
    if (confirm("Press a button!")) {
      let p = {
        component: this.component,
        application: 'comment',
        mediaType: this.mediaType,
        ids: obj['id']
      };
      this._remove.comment(p).subscribe(
        data => {
          //this.btn_process = false;
          if (data["status"] == "1") {

            this._global.showMessage({ "type": 'success', "message": this._global.getVal(data, 'message.info', '') });
          } else {
            this._global.showMessage({ "type": 'success', "message": this._global.getVal(data, 'message.error', '') });

          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    } else {
      console.log("You pressed Cancel!");
    }

  }
  getCommentCount(no) {
    this.commentCount.emit(no);
  }
  loadComment() {

    let pa = {
      component: this.component,
      application: 'comment',
      start: 0,
      rows: this.rows,
      mediaId: this.mediaId,
      sortOrder: 'desc',
      sortString: 'createdTime'
    };
    this._searchService.appcomment(pa).subscribe(
      commentList => {
        this.dataLoding = false;
        if (!_.isEmpty(this._global.getVal(commentList, 'response.docs', ''))) {
          this.params = this._global.getVal(commentList, 'request', {});
          this.comment_count = this._global.getVal(commentList, 'response.numFound', '0');
          this.comments = this._global.getVal(commentList, 'response.docs', {});
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  onScrollDown() {
    if (!this.dataLoding) {
      this.dataLoding = true;
      if (this.comment_count <= this.pageCounter * this.rows) {
        this.dataLoding = false;
      } else {
        let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.rows;
        p['component'] = this.component;
        this._searchService.appcomment(p).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.comments = this.comments.concat(this._global.getVal(data, 'response.docs', []));
              this.dataLoding = false;
              this.pageCounter += 1;
              this.params = this._global.getVal(data, 'request', '');
            } else {
              this.dataLoding = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });

      }
    }
  }
  saveComment() {

    this.comment_error = { "description": "" };
    this.btn_process = true;
    let p = this.commentForm.value;
    p = this._global.paramsRemoveNull(p);
    p['mediaName'] = this.mediaName;
    p['mediaId'] = this.mediaId
    p['application'] = 'comment';
    p['status'] = 'pending';
    p['rating'] = this.commentRate;
    p['component'] = this.component;
    p['mediaType'] = this.mediaType;
    this._createService.comment(p).subscribe(
      data => {
        this.btn_process = false;
        if (data["status"] == "1") {
          this.comment_count++;
          this.getCommentCount(this.comment_count);
          console.log(" this.comments_count", this.comments_count)
          this._global.showMessage({ "type": 'success', "message": this._global.getVal(data, 'message.info', '') });
          if (!this.metaComment) {
            let c = this.comments;
            this.comments = [];
            this.comments.push(data["response"]);
            this.comments = this.comments.concat(c);
          } else {
            let c = this.meta_comments;
            this.meta_comments = [];
            this.meta_comments.push(data["response"]);
            this.meta_comments = this.meta_comments.concat(c);
            this.meta_count = this.meta_count + 1;
          }
          this.commentForm.reset();
          this.commentRate = 0;
          this.form_renter = false;
        } else {
          for (let key in data["errors"]) {
            this.comment_error[key] = data["errors"][key]["message"];
          }
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  gotoLogin() {
    this.router.navigate(['/login'], { queryParams: { returnUrl: this.loginurl, 'navigateByUrl': true } });
  }
  updateComment(id, key) {
    this.comment_update_error = { "name": "", "description": "" };
    this.btn_update_process = true;
    let p = this.commentEditForm.value;
    p = this._global.paramsRemoveNull(p);
    p['mediaName'] = this.mediaName;
    p['mediaId'] = this.mediaId;
    p['id'] = id;
    p['application'] = 'comment';
    p['rating'] = this.commentRate;
    p['component'] = this.component;
    p['mediaType'] = this.mediaType;
    this._save.commentUpdate(p).subscribe(
      data => {
        this.btn_update_process = false;
        if (data["status"] == "1") {
          this.comment_count++;
          this._global.showMessage({ "type": 'success', "message": this._global.getVal(data, 'message.info', '') });
          if (!this.metaComment) {
            this.comments[key] = data["response"];
          } else {
            this.meta_comments[key] = data["response"];
          }
          this.commentEditForm.reset();
          this.comment_edit_show = {};

        } else {
          for (let key in data["errors"]) {
            this.comment_update_error[key] = data["errors"][key]["message"];
          }
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

}
